import React from "react";
// import video from "/Users/thankyoudom/Documents/repos/belleupdate/treact/src/images/demox.gif"

export default ({
  
}) => {
  return (
  {/*
<div style={{ textAlign: "center", marginTop: "2rem" }}>
<img
  src={video}
  title="Demo GIF"
  style={{
    maxWidth: "100%",
    backgroundColor: "#f3f4f6"
  }}
/>
    </div>
    */}
  );
};








